import IconButton from "@mui/material/IconButton";

import { styled as muiStyled } from "@mui/system";
import { globalColors } from "../../Utils/colors";

import {
  PreviewDesktopIcon,
  PreviewMobileIcon,
  PreviewTabletIcon,
} from "../Custom/Buttons/ButtonIcons";

interface PreviewToggleButtonsPropType {
  previewType: string;
  setPreviewType: (e: string) => void;
  handlePreviewClick?: () => void;
  isShareMode?: boolean;
}

const DEVICES = [
  {
    label: "Desktop",
    value: "pc",
    iconRenderer: (isSelected: Boolean) => (
      <PreviewDesktopIcon isSelected={isSelected} />
    ),
  },
  {
    label: "Mobile",
    value: "mobile",
    iconRenderer: (isSelected: Boolean) => (
      <PreviewMobileIcon isSelected={isSelected} />
    ),
  },
  {
    label: "Tablet",
    value: "tab",
    iconRenderer: (isSelected: Boolean) => (
      <PreviewTabletIcon isSelected={isSelected} />
    ),
  },
];

export const ButtonGroupContainer = muiStyled("div")({
  display: "flex",
  gap: "10px",
});

export const StyledIconButton = muiStyled(IconButton)<{ isSelected: Boolean }>(
  (props: any) => ({
    borderRadius: "5px",
    color: props.isSelected ? globalColors.white : globalColors.primary,
    backgroundColor: props.isSelected
      ? globalColors.primary
      : globalColors.white,

    "&:hover": {
      backgroundColor: props.isSelected
        ? globalColors.primary
        : globalColors.hoverColor,
    },
  })
);

export default function PreviewToggleButtons({
  previewType,
  setPreviewType,
  handlePreviewClick,
  isShareMode = false
}: PreviewToggleButtonsPropType) {
  return (
    <ButtonGroupContainer>
      {DEVICES.filter((device) => isShareMode ? device.value !== "tab" : device).map((device) => {
        const isSelected = previewType === device.value;

        return (
          <StyledIconButton
            key={device.value}
            disableRipple
            isSelected={isSelected}
            onClick={() => {
              setPreviewType(device.value);
            }}
          >
            {device.iconRenderer(isSelected)}
          </StyledIconButton>
        );
      })}
    </ButtonGroupContainer>
  );
}
